import { render, staticRenderFns } from "./InstitutionForm.vue?vue&type=template&id=2f95c075&"
import script from "./InstitutionForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports